import { Component } from '@angular/core';
import { NucEmptyStateComponent } from '@relayter/rubber-duck';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'standard-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    imports: [NucEmptyStateComponent, RouterLink]
})
export class NotFoundComponent {}
